function headerMenu() {
  return {
    isOpen: false,
    show: false,
    menu: null,
    activeButton: null,
    openIndex: null,
    isMobile: window.innerWidth < 768,

    init() {
      // Add resize handler
      window.addEventListener("resize", () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;

        // If view mode changed, close the menu
        if (wasMobile !== this.isMobile) {
          this.closeMenu();
        }
      });
    },

    mouseEnter(index) {
      if (this.isMobile) return;
      this.menu = index;
      this.activeButton = index;
      this.isOpen = true;
      this.$store.backdrop.toggle(true);
      this.$dispatch("menu-state-changed", { isOpen: true });
    },
    toggleMenu(index) {
      if (this.isMobile) return;
      if (this.isOpen && this.menu === index) {
        this.closeMenu();
      } else {
        this.menu = index;
        this.activeButton = index;
        this.isOpen = true;
        this.$store.backdrop.toggle(true);
      }
    },

    mouseLeave() {
      if (this.isMobile) return;
      this.isOpen = false;
      this.activeButton = null;
      this.$store.backdrop.toggle(false);
      this.$dispatch("menu-state-changed", { isOpen: false });
    },

    closeMenu() {
      this.isOpen = false;
      this.menu = null;
      this.openIndex = null;
      this.$store.backdrop.toggle(false);

      // Update header state directly to eliminate delay
      const headerElement = document.querySelector('[x-data*="header"]');
      if (headerElement && headerElement._x_dataStack) {
        const headerData = headerElement._x_dataStack[0];
        if (headerData && headerData.menuIsOpen !== undefined) {
          headerData.menuIsOpen = false;
          headerData.handleScroll();
        }
      }

      this.$dispatch("menu-state-changed", { isOpen: false });
    }
  };
}

export default headerMenu;
